import React from 'react';
import { number, oneOf, string } from 'prop-types';
import classnames from 'classnames';

import './Badge.scss';

function Badge({ status, content, className }) {
    const rootClassnames = classnames(
        'badge',
        {
            [`badge-status-${status}`]: status,
        },
        className,
    );

    return <div className={rootClassnames}>{content}</div>;
}

Badge.propTypes = {
    /** The content rendered within the badge. */
    content: number.isRequired,
    status: oneOf(['error', 'warning', 'info', 'success']),
    className: string,
};

Badge.defaultProps = {
    status: 'info',
    className: '',
};

export default Badge;
